import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentConfig } from '@clooper/core';

@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss']
})
export class SocialLoginComponent implements OnInit {

  @Input() page: string;
  action: string = 'Sign in'

  endpoint: string;

  constructor(
    private config: EnvironmentConfig
  ) {
    this.endpoint = this.config.api + 'auth/oauth/';
  }

  ngOnInit(): void {
    if (this.page === 'signup') {
      this.action = 'Sign up';
    }
  }

  signin_with(provider: string) {
    window.location.href = this.endpoint + provider
  }

}
